<div class="pasoPago">
  <div class="tituloInt tituloPago">{{ 'DETALLES_DE_PAGO' | translate }}</div>
  <div class="onoffswitch-wrapGeneral">
    <!-- <div class="onoffswitch-wrap">
      <div class="onoffswitch">
        <input type="checkbox" name="onoffswitch03" id="myonoffswitch03" class="onoffswitch-checkbox">
        <label class="onoffswitch-label" for="myonoffswitch03"></label>
      </div>
      <label class="onoffswitch-label-text" for="myonoffswitch03">Pre-venta</label>
    </div> -->
    <div class="onoffswitch-wrap checked" *ngIf="tienePermiso('VentaFacturar')">
      <div class="onoffswitch">
        <input
          type="checkbox"
          name="facturaCheck"
          id="myfacturaCheck"
          class="onoffswitch-checkbox"
          (change)="changeEmitirFactura()"
          [checked]="emitirFactura"
        />
        <label class="onoffswitch-label" for="myfacturaCheck"></label>
      </div>
      <label class="onoffswitch-label-text" for="myfacturaCheck">{{
        'FACTURA' | translate
      }}</label>
    </div>
    <div
      class="onoffswitch-wrap checked"
      *ngIf="
        tienePermiso('VentaFacturar') &&
        conf.DatosResult.AppConfigJsonPago.ImprimirFacturaSimpXDefecto === '1'
      "
    >
      <div class="onoffswitch">
        <input
          type="checkbox"
          name="facturaSimpleCheck"
          id="myfacturaSimpleCheck"
          class="onoffswitch-checkbox"
          (change)="changeEmitirFacturaSimple()"
          [checked]="emitirFacturaSimple"
        />
        <label class="onoffswitch-label" for="myfacturaSimpleCheck"></label>
      </div>
      <label class="onoffswitch-label-text" for="myfacturaSimpleCheck">{{
        'FACTURA SIMPLE' | translate
      }}</label>
    </div>
    <div class="onoffswitch-wrap checked">
      <div class="onoffswitch">
        <input
          type="checkbox"
          name="albaranCheck"
          id="myalbaranCheck"
          class="onoffswitch-checkbox"
          (change)="changeEmitirAlbaran()"
          [checked]="emitirAlbaran"
        />
        <label class="onoffswitch-label" for="myalbaranCheck"></label>
      </div>
      <label class="onoffswitch-label-text" for="myalbaranCheck">{{
        'ALBARAN' | translate
      }}</label>
    </div>
    <div class="onoffswitch-wrap checked">
      <div class="onoffswitch">
        <input
          type="checkbox"
          name="contactoCheck"
          id="mycontactoCheck"
          class="onoffswitch-checkbox"
          (change)="changePedirContacto()"
          [checked]="pedirContacto"
        />
        <label class="onoffswitch-label" for="mycontactoCheck"></label>
      </div>
      <label class="onoffswitch-label-text" for="mycontactoCheck">{{
        'CONTACTO' | translate
      }}</label>
    </div>
  </div>
  <div
    class="pagoRow valePromo form-group-nocurrency"
    [formGroup]="promocionalesForm"
    *ngIf="conf.DatosResult.AppConfigJsonPago.CodigoPromocional === '1'"
  >
    <div class="tit-form-group">{{ 'CODIGO_PROMOCIONAL' | translate }}</div>
    <div>
      <div class="form-group-nocurrency">
        <input
          type="text"
          formControlName="codigopromocional"
          class="form-control"
          id="codigopromocionalinput"
          placeholder="{{ 'CODIGO_PROMOCIONAL' | translate }}"
          autocomplete="nope"
          maxlength="50"
        />

        <!-- The label for the input Aplicar translated on the .ts file -->
        <input
          type="button"
          id="codigopromocionalboton"
          class="pagar aceptar"
          formControlName="aplicarcodigopromocional"
          (click)="aplicarPromocional()"
        />
      </div>
    </div>
  </div>
  <!-- <div class="pagoRow valePromo form-group-nocurrency" [formGroup]="codigoClienteForm"
*ngIf="conf.DatosResult.AppConfigJsonPago.CodigoClienteAsociado === '1'">
  <div class="tit-form-group">{{ 'CODIGO_CLIENTE' | translate }}</div>
  <div>
    <div class="form-group-nocurrency ">
      <div class="form-group-nocurrency CodigoClienteForm">
      <select formControlName="tipoDocumento" type="33" class="form-control dropdown" id="tipoDocumentoInput"
          [ngClass]="{ 'is-invalid': g.tipoDocumento.invalid && g.tipoDocumento.touched }">
          <option value="">{{'TIPO_DOCUMENTO' | translate}}</option>
          <option *ngFor="let option of optionsTipoDoc" [value]="option">{{option}}</option>
        </select>
      <input
        type="text"
        formControlName="codigoCliente"
        class="form-control dni"
        [ngClass]="{ 'is-invalid': g.codigoCliente.invalid && g.codigoCliente.touched }"
        id="codigoClienteInput"
        placeholder="NIF"
        autocomplete="nope"
        maxlength=50
      />
    </div>
      <input
        type="button"
        id="codigoClienteBoton"
        class="pagar aceptar"
        formControlName="descuentoCodigoCliente"
        (click)="aplicarCodigoCliente()"
        value="Aplicar"/>
  </div>
</div> 
</div>-->
  <ticketing-validar-cliente-asociado
    *ngIf="conf.DatosResult.AppConfigJsonPago.CodigoClienteAsociado === '1'"
  ></ticketing-validar-cliente-asociado>
  <div class="ColsModPago">
    <div class="ColsModPago-izq" *ngIf="esVentaModificada">
      <div class="titulosModPago">{{ 'VENTA_ORIGINAL' | translateV2 }}:</div>
      <div class="InputsWrap" [formGroup]="pagosFormVenta">
        <div
          class="form-group doble-margin-doble"
          *ngIf="conf.DatosResult.AppConfigJsonPago.TM === '1'"
        >
          <div class="tit-form-group">{{ 'TARJETA_MONEDERO' | translate }}</div>
          <input
            type="text"
            class="form-control readonly"
            formControlName="monederoVenta"
            id="MonederoInputText"
            [placeholder]="placeholderValue"
            readonly
          />
          <!-- <input type="text" class="form-control" formControlName="codigoMonederoVenta" id="CodigoMonederoInputText" placeholder="CÓDIGO TARJETA" readonly> -->
        </div>
        <div
          class="form-group readonly"
          *ngIf="
            conf.DatosResult.AppConfigJsonPago.Prepago === '1' &&
            precioPrepago &&
            precioPrepago > 0
          "
        >
          <div class="tit-form-group">{{ 'PREPAGO' | translate }}</div>
          <input
            type="text"
            class="form-control readonly"
            formControlName="prepagoVenta"
            id="PrepagoInput"
            [value]="placeholderValue"
            readonly
          />
        </div>
        <div class="form-group readonly" *ngIf="isAplazado()">
          <div class="tit-form-group">{{ 'APLAZADO' | translate }}</div>
          <input
            type="text"
            class="form-control readonly"
            formControlName="aplazadoVenta"
            id="AplazadoInputText"
            [placeholder]="placeholderValue"
            readonly
          />
        </div>
        <div
          class="form-group doble-margin-simple"
          *ngIf="conf.DatosResult.AppConfigJsonPago.Transferencia === '1'"
        >
          <div class="tit-form-group">{{ 'TRANSFERENCIA' | translate }}</div>
          <input
            type="text"
            class="form-control"
            formControlName="trasferenciaVenta"
            id="TransferenciaInputText"
            [placeholder]="placeholderValue"
            readonly
          />
        </div>
        <div class="pagoRow readonly empty">
          <div class="tit-form-group">
            {{ 'SIMPIES' | translate }}
          </div>
          <div class="form-group-nocurrency">
            <input
              type="text"
              #prepagoInput
              formControlName="simpe"
              class="form-control"
              category="DIVISA"
              id="SimpeInput"
              [placeholder]="placeholderValue"
              readonly
            />
            <input
              type="button"
              class="pagar aceptar"
              (click)="openModalSimpe()"
              value="Calcular"
            />
          </div>
        </div>

        <div
          class="form-group doble-margin-simple"
          *ngIf="conf.DatosResult.AppConfigJsonPago?.OtrasFOP === '1'"
        >
          <div class="tit-form-group">{{ 'OTRAS_FOP' | translate }}</div>
          <input
            type="text"
            class="form-control"
            formControlName="otrasFop"
            [placeholder]="placeholderValue"
            readonly
          />
          <input
            type="button"
            class="pagar aceptar"
            (click)="aplicarPromocional()"
            value="{{ 'SELECCIONAR' | translate }}"
          />
        </div>
        <div
          class="form-group doble-margin-simple"
          *ngIf="conf.DatosResult.AppConfigJsonPago?.OtrasFOP === '1'"
        >
          <div class="tit-form-group">{{ 'OTRAS_FOP' | translate }}</div>
          <input
            type="text"
            class="form-control"
            formControlName="otrasFop"
            [placeholder]="placeholderValue"
            readonly
          />
          <input
            type="button"
            class="pagar aceptar"
            (click)="aplicarPromocional()"
            value="{{ 'SELECCIONAR' | translate }}"
          />
        </div>
        <div
          class="form-group doble-margin-doble"
          *ngIf="
            conf.DatosResult.AppConfigJsonTarjeta.TarjetaAdmiteTarjetaCredito ==
              '1' &&
            (conf.DatosResult.AppConfigJsonTarjeta.TarjetaPeriferico === 'D' ||
              conf.DatosResult.AppConfigJsonTarjeta.TarjetaPeriferico === 'L' ||
              conf.DatosResult.AppConfigJsonTarjeta.TarjetaPeriferico === 'DL')
          "
        >
          <div class="tit-form-group">{{ 'TARJETA' | translate }}</div>
          <input
            type="text"
            class="form-control"
            formControlName="tarjetaVenta"
            id="TarjetaInputText"
            [placeholder]="placeholderValue"
            readonly
          />
        </div>
        <div
          class="form-group doble-margin-doble readonly"
          *ngIf="conf.DatosResult.AppConfigJsonPago.Efectivo === '1'"
        >
          <div class="tit-form-group">{{ 'EFECTIVO' | translate }}</div>
          <input
            type="text"
            class="form-control"
            formControlName="recibidoVenta"
            id="RecibidoInputText"
            [placeholder]="placeholderValue"
            readonly
          />
        </div>
      </div>
    </div>
    <div class="ColsModPago-der">
      <div *ngIf="esVentaModificada" class="titulosModPago">
        {{ 'VENTA_MODIFICADA' | translateV2 }}:
      </div>
      <div class="InputsWrap" [formGroup]="pagosForm">
        <div
          class="pagoRow"
          *ngIf="conf.DatosResult.AppConfigJsonPago.TM === '1'"
        >
          <div *ngIf="!esVentaModificada" class="tit-form-group-doble">
            {{ 'TARJETA_MONEDERO' | translate }}
          </div>
          <div class="form-group-row">
            <div class="form-group">
              <div
                class="subtit-form-group"
                [ngClass]="{ izquierda: TMActivo }"
              >
                <label for="CodigoMonederoInput">
                  {{ 'SALDO' | translate }}
                  <input
                    type="text"
                    class="labelInput"
                    readonly
                    #saldoMonederoInput
                    autocomplete="nope"
                    formControlName="saldoMonedero"
                    id="SaldoMonederoInput"
                    [placeholder]="placeholderValue"
                    [value]="saldoMonederoInput.value"
                    category="DIVISA"
                  />
                  {{ divisaSimbolo }}
                </label>
              </div>
              <input
                type="text"
                autocomplete="nope"
                class="form-control TMCodigoForm"
                #monederoInput
                [value]="monederoInput.value"
                [ngClass]="{
                  verde: TMActivo,
                  naranja: TMCaducado,
                  rojo:
                    TMErroneo ||
                    this.pagosForm.controls['codigoMonedero'].invalid
                }"
                formControlName="monedero"
                id="MonederoInput"
                [placeholder]="placeholderValue"
                category="DIVISA"
                readonly
              />
            </div>
            <div class="form-group-nocurrency">
              <input
                type="text"
                class="form-control TMCodigoForm"
                [ngClass]="{
                  verde: TMActivo,
                  naranja: TMCaducado,
                  rojo:
                    TMErroneo ||
                    this.pagosForm.controls['codigoMonedero'].invalid
                }"
                autocomplete="nope"
                formControlName="codigoMonedero"
                id="CodigoMonederoInput"
                [placeholder]="codigoTarjeta"
                (focus)="focusTarjetaMonederoValue($event)"
                (blur)="onBlurTarjetaMonederoValue()"
                (keyup.enter)="validarTarjetaMonedero()"
              />
            </div>
          </div>
        </div>
        <div
          class="pagoRow readonly empty"
          *ngIf="
            conf.DatosResult.AppConfigJsonPago.Prepago === '1' &&
            precioPrepago &&
            precioPrepago > 0
          "
        >
          <div *ngIf="!esVentaModificada" class="tit-form-group">
            {{ 'PREPAGO' | translate }}
          </div>
          <div class="form-group-wrap">
            <div class="form-group">
              <input
                type="text"
                #prepagoInput
                formControlName="prepago"
                [value]="
                  conversor(precioPrepago)
                    | myCurrency
                      : divisaSimboloDecimal
                      : divisaDecimales
                      : divisaPosicion
                      : divisaSimbolo
                      : divisaSimboloDerecha
                      : divisaSimbSeparacionMiles
                "
                class="form-control readonly"
                category="DIVISA"
                id="PrepagoInput"
                [placeholder]="placeholderValue"
                readonly
              />
            </div>
          </div>
        </div>
        <div class="pagoRow" *ngIf="isAplazado()">
          <div *ngIf="!esVentaModificada" class="tit-form-group">
            {{ 'APLAZADO' | translate }}
          </div>
          <div class="form-group-wrap">
            <div class="form-group">
              <!-- Input oculto que contiene el valor real -->
              <input
                type="text"
                autocomplete="nope"
                [ngClass]="{ 'active-form': isSelected(aplazadoInput) }"
                #aplazadoInput
                formControlName="aplazado"
                class="form-control"
                id="AplazadoInput"
                [placeholder]="placeholderValue"
                category="DIVISA"
                readonly
                hidden
              />
              <!-- Input visual que muestra el valor con el formato deseado -->
              <input
                type="text"
                [value]="aplazadoVisual"
                (input)="actualizarAplazado($event.target.value)"
                class="form-control"
                readonly
              />
            </div>
          </div>
        </div>
        <!-- <div class="pagoRow" *ngIf="isAplazado()">
        <div *ngIf="!esVentaModificada" class="tit-form-group">{{ 'APLAZADO' | translate }}</div>
          <div class="form-group-wrap">
            <div class="form-group">
          <input
            type="text"
            autocomplete="nope"
            [ngClass]="{'active-form': isSelected(aplazadoInput) }"
            #aplazadoInput
            formControlName="aplazado"
            class="form-control"
            id="AplazadoInput"
            [placeholder]="placeholderValue"
            category="DIVISA"
            readonly
          />
          </div>
        </div>
      </div>    -->
        <!-- <div class="pagoRow" *ngIf="isAplazado()">
        <div *ngIf="!esVentaModificada" class="tit-form-group">{{ 'APLAZADO' | translate }}</div>
        <div class="form-group-wrap">
          <div class="form-group">
            <input
              type="text"
              autocomplete="nope"
              [ngClass]="{'active-form': isSelected(aplazadoInput) }"
              #aplazadoInput
              formControlName="aplazado"
              class="form-control"
              id="AplazadoInput"
              [placeholder]="placeholderValue"
              category="DIVISA"
              readonly
              [value]="conversor(pagosForm.get('aplazado').value) | myCurrency: divisaSimboloDecimal : divisaDecimales : divisaPosicion: divisaSimbolo : divisaSimboloDerecha : divisaSimbSeparacionMiles"
            />
            <input
              type="hidden"
              formControlName="aplazado"
              [value]="conversor(pagosForm.get('aplazado').value)"
            />
          </div>
        </div>
      </div> -->
        <div
          class="pagoRow"
          *ngIf="conf.DatosResult.AppConfigJsonPago.Transferencia === '1'"
        >
          <div *ngIf="!esVentaModificada" class="tit-form-group">
            {{ 'TRANSFERENCIA' | translate }}
          </div>
          <div class="form-group-wrap">
            <div class="form-group">
              <input
                type="text"
                autocomplete="nope"
                [ngClass]="{ 'active-form': isSelected(transferenciaInput) }"
                #transferenciaInput
                [value]="transferenciaInput.value"
                formControlName="transferencia"
                class="form-control"
                id="TransferenciaInput"
                [placeholder]="placeholderValue"
                (focus)="focusTransferenciaValue($event)"
                (blur)="onBlurValue($event)"
                category="DIVISA"
              />
            </div>
          </div>
        </div>
        <!-- ! Have to put this condition conf.DatosResult.AppConfigJsonPago?.OtrasFOP === '1' instead of true -->
        <!-- * -->

        <div
          class="pagoRow readonly empty"
          *ngIf="conf.DatosResult.AppConfigJsonPago.SINPE === '1'"
        >
          <div class="tit-form-group">
            {{ 'SINPE' | translate }}
          </div>
          <div class="form-group form-group-nocurrency">
            <input
              type="text"
              autocomplete="nope"
              #simpeInput
              formControlName="simpe"
              class="form-control readonly form-simpe"
              category="DIVISA"
              id="SimpeInput"
              [placeholder]="placeholderValue"
              (blur)="onBlurValue($event)"
              [value]="
                conversor(precioSimpe)
                  | myCurrency
                    : divisaSimboloDecimal
                    : divisaDecimales
                    : divisaPosicion
                    : divisaSimbolo
                    : divisaSimboloDerecha
                    : divisaSimbSeparacionMiles
              "
              readonly
            />
            <input
              type="button"
              class="pagar aceptar"
              (click)="openModalSimpe()"
              value="Calcular"
            />
          </div>
        </div>

        <div
          class="pagoRow valePromo form-group-nocurrency"
          *ngIf="conf.DatosResult.AppConfigJsonPago?.OtrasFOP === '1'"
        >
          <!-- <div *ngIf="!esVentaModificada" class="tit-form-group">
            {{ 'TRANSFERENCIA' | translate }}
          </div> -->
          <div class="tit-form-group">{{ 'OTRAS_FOP' | translate }}</div>
          <div class="form-group form-group-nocurrency">
            <input
              type="text"
              autocomplete="nope"
              #fopInput
              class="form-control"
              formControlName="otrasFop"
              [placeholder]="placeholderValue"
              category="DIVISA"
              readonly
            />
          </div>
          <div class="form-group form-group-nocurrency">
            <input
              type="button"
              class="pagar aceptar"
              (click)="openDialog(fopInput)"
              value="{{ 'SELECCIONAR' | translate }}"
            />
          </div>
        </div>
        <div
          class="pagoRow"
          *ngIf="
            conf.DatosResult.AppConfigJsonTarjeta.TarjetaAdmiteTarjetaCredito ==
            '1'
          "
        >
          <div *ngIf="!esVentaModificada" class="tit-form-group">
            {{ 'TARJETA' | translate }}
          </div>
          <div class="form-group-wrap">
            <div
              class="form-group"
              *ngIf="
                conf.DatosResult.AppConfigJsonTarjeta.TarjetaPeriferico ===
                  'L' ||
                conf.DatosResult.AppConfigJsonTarjeta.TarjetaPeriferico === 'DL'
              "
            >
              <div class="subtit-form-group">
                <label for="PinpadInput">{{ 'PINPAD' | translate }}</label>
              </div>
              <input
                type="text"
                autocomplete="nope"
                formControlName="pinpad"
                class="form-control"
                [ngClass]="{ 'active-form': isSelected(pinpadInput) }"
                id="PinpadInput"
                #pinpadInput
                [placeholder]="placeholderValue"
                [value]="pinpadInput.value"
                (focus)="focusValue($event)"
                (blur)="onBlurValue($event)"
                category="DIVISA"
              />
            </div>
            <div
              class="form-group"
              *ngIf="
                conf.DatosResult.AppConfigJsonTarjeta.TarjetaPeriferico ===
                  'D' ||
                conf.DatosResult.AppConfigJsonTarjeta.TarjetaPeriferico === 'DL'
              "
            >
              <div class="subtit-form-group">
                <label for="DatafonoInput">{{ 'DATAFONO' | translate }}</label>
              </div>
              <input
                type="text"
                autocomplete="nope"
                #datafonoInput
                formControlName="datafono"
                [ngClass]="{ 'active-form': isSelected(datafonoInput) }"
                class="form-control"
                id="DatafonoInput"
                [placeholder]="placeholderValue"
                [value]="datafonoInput.value"
                (focus)="focusValue($event)"
                (blur)="onBlurValue($event)"
                category="DIVISA"
              />
            </div>
          </div>
        </div>
        <div>
          <div
            class="pagoRow"
            *ngIf="conf.DatosResult.AppConfigJsonPago.Efectivo === '1' || conf.DatosResult.AppConfigJsonPago.GestorEfectivo?.GestorActivo === '1'"
          >
            <div *ngIf="!esVentaModificada" class="tit-form-group">
              {{ 'EFECTIVO' | translate }}
            </div>
            <div class="form-group-wrap">
              <div class="form-group">
                <div class="subtit-form-group">
                  <label for="RecibidoInput">{{
                    'RECIBIDO' | translate
                  }}</label>
                </div>
                <!--[autofocus]="conf.DatosResult.AppConfigJsonPago.Foco=='efectivo'"               (change)="changeValue($event)"-->
                <input
                  [autofocus]="
                    conf.DatosResult.AppConfigJsonPago.Foco &&
                    conf.DatosResult.AppConfigJsonPago.Foco == 'efectivo'
                  "
                  type="text"
                  autocomplete="nope"
                  #recibidoInput
                  formControlName="efectivo"
                  min="0"
                  [readonly]="isCashManagerEnabled()"
                  [ngClass]="{ 'active-form': isSelected(recibidoInput) }"
                  class="form-control"
                  id="RecibidoInput"
                  [placeholder]="placeholderValue"
                  (focus)="focusValue($event)"
                  (blur)="onBlurValue($event)"
                  category="DIVISA"
                />
              </div>
              <div class="form-group readonly">
                <div class="subtit-form-group">
                  <label for="CambioInput">{{ 'CAMBIO' | translate }}</label>
                </div>
                <input
                  type="text"
                  class="form-control readonly"
                  [value]="
                    cambio
                      | myCurrency
                        : divisaSimboloDecimal
                        : divisaDecimales
                        : divisaPosicion
                        : divisaSimbolo
                        : divisaSimboloDerecha
                        : divisaSimbSeparacionMiles
                  "
                  id="CambioInput"
                  readonly
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="checkboxStyledWrap">
    <div class="checkboxStyledWrap" [formGroup]="optionsForm">
      <div
        class="checkboxStyled"
        [ngClass]="{ checked: optionsForm.controls.tickets.value }"
      >
        <div class="center">
          <label class="label" for="myCheckboxStyled00">
            <input
              class="label__checkbox"
              type="checkbox"
              formControlName="tickets"
              (change)="avisarConfiguracion($event)"
              id="myCheckboxStyled00"
            />
            <span class="label__check">
              <img
                class="svg"
                src="assets/img/checkbox-mark.svg"
                alt="icono checkbox"
              />
            </span>
          </label>
        </div>
        <label class="label__text" for="myCheckboxStyled00">{{
          'OPCIONES_PAGO_TICKETS' | translate
        }}</label>
      </div>
      <div
        class="checkboxStyled"
        [ngClass]="{ checked: optionsForm.controls.cortarTickets.value }"
      >
        <div class="center">
          <label class="label" for="myCheckboxStyled01">
            <input
              class="label__checkbox"
              type="checkbox"
              formControlName="cortarTickets"
              id="myCheckboxStyled01"
            />
            <span class="label__check">
              <img
                class="svg"
                src="assets/img/checkbox-mark.svg"
                alt="icono checkbox"
              />
            </span>
          </label>
        </div>
        <label class="label__text" for="myCheckboxStyled01">{{
          'OPCIONES_PAGO_CORTAR_TICKETS' | translate
        }}</label>
      </div>
      <!--<div
    <div class="checkboxStyledWrap" [formGroup]="optionsForm">
      <div
        class="checkboxStyled"
        [ngClass]="{ checked: optionsForm.controls.tickets.value }"
      >
        <div class="center">
          <label class="label" for="myCheckboxStyled00">
            <input
              class="label__checkbox"
              type="checkbox"
              formControlName="tickets"
              (change)="avisarConfiguracion($event)"
              id="myCheckboxStyled00"
            />
            <span class="label__check">
              <img
                class="svg"
                src="assets/img/checkbox-mark.svg"
                alt="icono checkbox"
              />
            </span>
          </label>
        </div>
        <label class="label__text" for="myCheckboxStyled00">{{
          'OPCIONES_PAGO_TICKETS' | translate
        }}</label>
      </div>
      <div
        class="checkboxStyled"
        [ngClass]="{ checked: optionsForm.controls.cortarTickets.value }"
      >
        <div class="center">
          <label class="label" for="myCheckboxStyled01">
            <input
              class="label__checkbox"
              type="checkbox"
              formControlName="cortarTickets"
              id="myCheckboxStyled01"
            />
            <span class="label__check">
              <img
                class="svg"
                src="assets/img/checkbox-mark.svg"
                alt="icono checkbox"
              />
            </span>
          </label>
        </div>
        <label class="label__text" for="myCheckboxStyled01">{{
          'OPCIONES_PAGO_CORTAR_TICKETS' | translate
        }}</label>
      </div>
      <!--<div
    class="checkboxStyled"
    [ngClass]="{ checked: optionsForm.controls.datosContacto.value }"
  >
    <div class="center">
      <label class="label" for="myCheckboxStyled02">
        <input
          class="label__checkbox"
          type="checkbox"
          formControlName="datosContacto"
          id="myCheckboxStyled02"
        />
        <span class="label__check">
          <img
            class="svg"
            src="assets/img/checkbox-mark.svg"
            alt="icono checkbox"
            (click)="abrirModalDatosContacto()"
          />
        </span>
      </label>
    </div>
    <label class="label__text" for="myCheckboxStyled02">{{
      'OPCIONES_PAGO_CONTACTO' | translate
    }}</label>
  </div>-->
      <div
        class="checkboxStyled"
        [ngClass]="{ checked: optionsForm.controls.entradaConjunta.value }"
      >
        <div class="center">
          <label class="label" for="myCheckboxStyled02">
            <input
              class="label__checkbox"
              type="checkbox"
              formControlName="entradaConjunta"
              id="myCheckboxStyled02"
              (change)="imprimirEntradaConjunta()"
            />
            <span class="label__check">
              <img
                class="svg"
                src="assets/img/checkbox-mark.svg"
                alt="icono checkbox"
              />
            </span>
          </label>
        </div>
        <label class="label__text" for="myCheckboxStyled04">{{
          'OPCIONES_PAGO_ENTRADA_CONJUNTA' | translate
        }}</label>
      </div>
      <!-- <div *ngIf="showEnvioMail"
      <div
        class="checkboxStyled"
        [ngClass]="{ checked: optionsForm.controls.entradaConjunta.value }"
      >
        <div class="center">
          <label class="label" for="myCheckboxStyled02">
            <input
              class="label__checkbox"
              type="checkbox"
              formControlName="entradaConjunta"
              id="myCheckboxStyled02"
              (change)="imprimirEntradaConjunta()"
            />
            <span class="label__check">
              <img
                class="svg"
                src="assets/img/checkbox-mark.svg"
                alt="icono checkbox"
              />
            </span>
          </label>
        </div>
        <label class="label__text" for="myCheckboxStyled04">{{
          'OPCIONES_PAGO_ENTRADA_CONJUNTA' | translate
        }}</label>
      </div>
      <!-- <div *ngIf="showEnvioMail"
      [ngClass]="{ 'checkboxStyled': true, 'checked': optionsForm.controls.enviarMail.value }">
      <div class="center">
        <label class="label" for="myCheckboxStyledSendMail">
          <input
            class="label__checkbox"
            type="checkbox"
            formControlName="enviarMail"
            id="myCheckboxStyledSendMail"
            (change)="sendMailModal(optionsForm.controls.enviarMail.value)"
          />
          <span class="label__check">
            <img
              class="svg"
              src="assets/img/checkbox-mark.svg"
              alt="icono checkbox"
            />
          </span>
        </label>
      </div>
      <label class="label__text" for="myCheckboxStyledSendMail">{{
        'OPCIONES_PAGO_ENVIO_MAIL' | translate
      }}</label>
    </div> -->
      <div
        class="checkboxStyled"
        [ngClass]="{ checked: optionsForm.controls.etiquetas.value }"
      >
        <div class="center">
          <label class="label" for="myCheckboxStyled03">
            <input
              class="label__checkbox"
              type="checkbox"
              formControlName="etiquetas"
              id="myCheckboxStyled03"
              (change)="imprimirEtiquetas()"
            />
            <span class="label__check">
              <img
                class="svg"
                src="assets/img/checkbox-mark.svg"
                alt="icono checkbox"
              />
            </span>
          </label>
        </div>
        <label class="label__text" for="myCheckboxStyled03">{{
          'OPCIONES_PAGO_ETIQUETAS' | translate
        }}</label>
      </div>
    </div>

    <div
      *ngIf="showEnvioMail"
      [ngClass]="{
        checkboxStyled: true,
        checked: checkEnvioMail,
        checkMail: true
      }"
    >
      <div
        *ngIf="showEnvioMail"
        [ngClass]="{
          checkboxStyled: true,
          checked: checkEnvioMail,
          checkMail: true
        }"
      >
        <div class="center">
          <label class="label" for="myCheckboxStyledSendMailVenta">
            <input
              class="label__checkbox"
              type="checkbox"
              [(ngModel)]="checkEnvioMail"
              id="myCheckboxStyledSendMailVenta"
              (change)="sendMailModal()"
            />
            <span class="label__check">
              <img
                class="svg"
                src="assets/img/checkbox-mark.svg"
                alt="icono checkbox"
              />
            </span>
          </label>
        </div>
        <label class="label__text" for="myCheckboxStyledSendMailVenta">{{
          'OPCIONES_PAGO_ENVIO_MAIL' | translate
        }}</label>
      </div>
    </div>
  </div>
</div>
